import { render, staticRenderFns } from "./patients.vue?vue&type=template&id=3bcacae8&scoped=true&"
import script from "./patients.vue?vue&type=script&lang=js&"
export * from "./patients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcacae8",
  null
  
)

export default component.exports